/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreProfileStoreDetails } from './StoreProfileStoreDetails';
import {
    StoreProfileStoreDetailsFromJSON,
    StoreProfileStoreDetailsFromJSONTyped,
    StoreProfileStoreDetailsToJSON,
    StoreProfileStoreDetailsToJSONTyped,
} from './StoreProfileStoreDetails';
import type { StoreProfileChangeRequest } from './StoreProfileChangeRequest';
import {
    StoreProfileChangeRequestFromJSON,
    StoreProfileChangeRequestFromJSONTyped,
    StoreProfileChangeRequestToJSON,
    StoreProfileChangeRequestToJSONTyped,
} from './StoreProfileChangeRequest';

/**
 * 
 * @export
 * @interface StoreProfileDetails
 */
export interface StoreProfileDetails {
    /**
     * 
     * @type {string}
     * @memberof StoreProfileDetails
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreProfileDetails
     */
    published: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileDetails
     */
    url?: string;
    /**
     * 
     * @type {Date}
     * @memberof StoreProfileDetails
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StoreProfileDetails
     */
    updatedAt?: Date;
    /**
     * 
     * @type {StoreProfileStoreDetails}
     * @memberof StoreProfileDetails
     */
    store: StoreProfileStoreDetails;
    /**
     * 
     * @type {StoreProfileChangeRequest}
     * @memberof StoreProfileDetails
     */
    changeRequest?: StoreProfileChangeRequest;
}

/**
 * Check if a given object implements the StoreProfileDetails interface.
 */
export function instanceOfStoreProfileDetails(value: object): value is StoreProfileDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('published' in value) || value['published'] === undefined) return false;
    if (!('store' in value) || value['store'] === undefined) return false;
    return true;
}

export function StoreProfileDetailsFromJSON(json: any): StoreProfileDetails {
    return StoreProfileDetailsFromJSONTyped(json, false);
}

export function StoreProfileDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'published': json['published'],
        'url': json['url'] == null ? undefined : json['url'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'store': StoreProfileStoreDetailsFromJSON(json['store']),
        'changeRequest': json['changeRequest'] == null ? undefined : StoreProfileChangeRequestFromJSON(json['changeRequest']),
    };
}

export function StoreProfileDetailsToJSON(json: any): StoreProfileDetails {
    return StoreProfileDetailsToJSONTyped(json, false);
}

export function StoreProfileDetailsToJSONTyped(value?: StoreProfileDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'published': value['published'],
        'url': value['url'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'store': StoreProfileStoreDetailsToJSON(value['store']),
        'changeRequest': StoreProfileChangeRequestToJSON(value['changeRequest']),
    };
}

